import { render, staticRenderFns } from "./soil-area-echarts.vue?vue&type=template&id=4c3a5f24&scoped=true&"
import script from "./soil-area-echarts.vue?vue&type=script&lang=js&"
export * from "./soil-area-echarts.vue?vue&type=script&lang=js&"
import style0 from "./soil-area-echarts.vue?vue&type=style&index=0&id=4c3a5f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a5f24",
  null
  
)

export default component.exports